import { ComponentProps, JSXElementConstructor } from 'react';
import { CdaStructuredTextValue } from 'react-datocms/structured-text';

import BlogPostBlock from './BlogPostBlock';
import CardBlock from './CardBlock';
import CarouselBlock from './CarouselBlock';
import ComparisonBlock from './ComparisonBlock';
import ContentBlock from './ContentBlock';
import CtaBlock from './CtaBlock';
import CtaCardBlock from './CtaCardBlock';
import EventCardBlock from './EventCardBlock';
import FeatureBlock from './FeatureBlock';
import FeaturesItemBlock from './FeaturesItemBlock';
import GridBlock from './GridBlock';
import IconFeatureBlock from './IconFeatureBlock';
import ImageBlock from './ImageBlock';
import InfluencerBlock from './InfluencerBlock';
import PersonBlock from './PersonBlock';
import RichTextBlock from './RichTextBlock';
import SchedulingBlock from './SchedulingBlock';
import StatBlock from './StatBlock';
import SubscriptionBlock from './SubscriptionBlock';
import TestimonialBlock from './TestimonialBlock';
import TimelineBlock from './TimelineBlock';
import TrustpilotBlock from './TrustpilotBlock';
import ValuesCloudBlock from './ValuesCloudBlock';
import VideoBlock from './VideoBlock';

const SupportedBlocks = {
  FeatureBlock,
  ImageBlock,
  VideoBlock,
  CardBlock,
  PersonBlock,
  SubscriptionBlock,
  CarouselBlock,
  StatBlock,
  RichTextBlock,
  ValuesCloudBlock,
  TrustpilotBlock,
  EventCardBlock,
  ContentBlock,
  FeaturesItemBlock,
  BlogPostBlock,
  CtaBlock,
  SchedulingBlock,
  TestimonialBlock,
  GridBlock,
  TimelineBlock,
  InfluencerBlock,
  CtaCardBlock,
  IconFeatureBlock,
  ComparisonBlock,
};

export type Block = ComponentProps<(typeof SupportedBlocks)[keyof typeof SupportedBlocks]>;
export type StructuredText = CdaStructuredTextValue<Block>;

export default function BlockItem(props: Block) {
  const typeName = props.__typename.replace(/Record$/, '') as keyof typeof SupportedBlocks;
  const Component = typeName in SupportedBlocks && (SupportedBlocks[typeName] as JSXElementConstructor<unknown>);

  if (Component)
    return (
      <Component
        key={props.id}
        {...props}
      />
    );

  console.warn(' ✗ %s is not supported as a block type', typeName);
  return null;
}
